module.exports = __webpack_public_path__ + "static/media/KZ.ac05cedd.svg";